import { provideTimePeriod, TimePeriodFactoryType } from '@rma/dashboard/reporting/public/util-reporting-time-period';
import { SyndicationStatisticsService } from './syndication-statistics.service';

export function provideSyndicationStatistics(periodType: TimePeriodFactoryType) {
  return [provideTimePeriod(periodType), SyndicationStatisticsService];
}
